import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/codebuild/output/src1917090841/src/company/node_modules/@nextui-org/link/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1917090841/src/company/node_modules/next/dist/client/image-component.js");
